var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.4131C0.114007 18.9811 0.236156 18.5531 0.346091 18.1211C0.639251 16.9595 0.920195 15.7979 1.21743 14.6403C1.24593 14.5221 1.31922 14.3958 1.40472 14.3102C5.00814 10.6949 8.61971 7.08377 12.2272 3.4726C12.2638 3.43592 12.3005 3.40331 12.3249 3.38293C13.75 4.80947 15.1669 6.22785 16.6042 7.66661C16.5839 7.68699 16.5391 7.73998 16.4943 7.78889C12.9031 11.3797 9.31596 14.9745 5.72068 18.5613C5.61482 18.6672 5.46824 18.7528 5.32573 18.7895C3.77036 19.1889 2.21498 19.5721 0.655537 19.9633C0.618893 19.9715 0.582248 19.9919 0.549674 20.0041C0.472313 20.0041 0.394951 20.0041 0.313518 20.0041C0.207655 19.8981 0.105863 19.7962 0 19.6903C0 19.5965 0 19.5028 0 19.4131Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8827 6.39494C16.4495 4.96026 15.0284 3.5378 13.5952 2.10311C13.982 1.71591 14.3729 1.32056 14.7719 0.92928C14.9511 0.749944 15.1302 0.562457 15.3297 0.415728C16.1278 -0.175264 17.3045 -0.130431 18.0374 0.538002C18.5382 0.994493 19.0187 1.47544 19.4706 1.97676C20.1424 2.72264 20.1709 3.85571 19.5724 4.66272C19.4951 4.76869 19.4095 4.86651 19.3159 4.95618C18.8395 5.43713 18.355 5.91807 17.8827 6.39494Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9339efc7857ac208890313eac6a65732.svg";
export { ForwardRef as ReactComponent };